export type ProductGalleryOnboardingStatus = 'dismissed' | 'completed'

export const PRODUCT_GALLERY_ONBOARDING_COOKIE_BASE = 'product-gallery-onboarding'
export const PRODUCT_GALLERY_ONBOARDING_VERSION = 'v1'
export const PRODUCT_GALLERY_ONBOARDING_COOKIE = `${PRODUCT_GALLERY_ONBOARDING_COOKIE_BASE}:${PRODUCT_GALLERY_ONBOARDING_VERSION}`
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365

export function getProductGalleryOnboardingCookieName(version = PRODUCT_GALLERY_ONBOARDING_VERSION) {
  return `${PRODUCT_GALLERY_ONBOARDING_COOKIE_BASE}:${version}`
}

export function readProductGalleryOnboardingStatus(cookieName = PRODUCT_GALLERY_ONBOARDING_COOKIE): ProductGalleryOnboardingStatus | null {
  const cookieEntry = document.cookie
    .split('; ')
    .find(entry => entry.startsWith(`${cookieName}=`))

  if (!cookieEntry) {
    return null
  }

  const cookieValue = decodeURIComponent(cookieEntry.split('=').slice(1).join('='))

  return (cookieValue === 'dismissed' || cookieValue === 'completed') ? cookieValue : null
}

export function writeProductGalleryOnboardingStatus(status: ProductGalleryOnboardingStatus, cookieName = PRODUCT_GALLERY_ONBOARDING_COOKIE) {
  document.cookie = `${cookieName}=${encodeURIComponent(status)}; Max-Age=${COOKIE_MAX_AGE_SECONDS}; Path=/; SameSite=Lax`
}
